import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { CurrentContext, MapContext, ReportContext } from '../models';
import { setCurrentContext, setMapContext, setMapFilter, setReportContext, setSelectedDio, setSelectedRegion } from '../clergy-comp-report-slice';
import { domesticMapSelection, handleRegionClick } from '../map-actions';
import { TcsmStates } from '../../../root/tcsm-model';
import { provMap } from '../dropdown/provinces-dropdown';
import { replaceAll } from '../../../global/helpers/string-helpers';


function resetSelectionTracking() {
	domesticMapSelection.currentDio = null;
	domesticMapSelection.currentRegion = null;
}

function onHomeClick(dispatch) {
	dispatch(setMapContext(MapContext.LANDING));
	dispatch(setCurrentContext(CurrentContext.LANDING));
	dispatch(setReportContext(null));
}

function onDomesticHomeClick(dispatch) {
	dispatch(setMapContext(MapContext.DOMESTIC));
	dispatch(setCurrentContext(CurrentContext.DOMESTIC));
	dispatch(setReportContext(ReportContext.PROVINCE));
	dispatch(setSelectedDio(null));
	dispatch(setSelectedRegion(null));
	dispatch(setMapFilter({ dio: null, region: null }));
	resetSelectionTracking();
	const svgMap = document.getElementById('domestic-svg');
	svgMap?.removeAttribute('transform');
	svgMap?.childNodes.forEach(region => {
		if (region.nodeName === 'g') (region as HTMLElement).removeAttribute('class');
		region?.childNodes.forEach(dio => { if (dio.nodeName === 'g') (dio as HTMLElement).removeAttribute('class'); });
	});

}

function provinceBackClick(dispatch, prov) {

	const svg = document.getElementById('domestic-svg');
	const regions: ChildNode[] = [];
	let region = null;
	svg.childNodes.forEach(a => {
		if (a.nodeName === 'g') {
			regions.push(a);
			if ((a as HTMLElement)?.getAttribute('prov') === prov) region = a;
		}
	});

	handleRegionClick(region as HTMLElement, regions as HTMLElement[], svg, dispatch, true);
}

function internationalDioBackClick(dispatch) {
	dispatch(setCurrentContext(CurrentContext.INTERNATIONAL));
	dispatch(setSelectedDio(null));
	dispatch(setSelectedRegion(null));
	dispatch(setMapFilter({ dio: null, region: null }));
	resetSelectionTracking();
	const svgMap = document.getElementById('international-svg');
	svgMap?.childNodes.forEach(dio => {
		if (dio.nodeName === 'g') (dio as HTMLElement).setAttribute('class', (dio as HTMLElement).getAttribute('class').replace('dark-grey', '').replace(' ', ''));
	});

}

export function HomeBackButtons() {

	const dispatch = useDispatch();

	return (
		<ul className='clergycomp-infographic-breadcrumb-list'>
			<li className='clergycomp-infographic-breadcrumb-list-item'><button type='button' onClick={() => onHomeClick(dispatch)}>Home</button></li>
		</ul>
	);

}

export function DomesticBackButtons() {
	const dispatch = useDispatch();

	return (
		<ul className='clergycomp-infographic-breadcrumb-list'>
			<li className='clergycomp-infographic-breadcrumb-list-item'><button type='button' onClick={() => onHomeClick(dispatch)}>Home</button></li>
			<li className='clergycomp-infographic-breadcrumb-list-item'><button type='button' onClick={() => onDomesticHomeClick(dispatch)}>All Domestic Dioceses</button></li>
		</ul>
	);

}

export function NonDomesticBackButtons() {
	const dispatch = useDispatch();
	return (
		<ul className='clergycomp-infographic-breadcrumb-list'>
			<li className='clergycomp-infographic-breadcrumb-list-item'><button type='button' onClick={() => onHomeClick(dispatch)}>Home</button></li>
			<li className='clergycomp-infographic-breadcrumb-list-item'><button type='button' >All Non-Domestic Dioceses</button></li>
		</ul >
	);

}

export function RegionBackButtons() {
	const dispatch = useDispatch();
	const currentRegion = useSelector<TcsmStates, string>(state => state?.clergyCompReportState?.selectedRegion);

	return (
		<ul className='clergycomp-infographic-breadcrumb-list'>
			<li className='clergycomp-infographic-breadcrumb-list-item'><button type='button' onClick={() => onHomeClick(dispatch)}>Home</button></li>
			<li className='clergycomp-infographic-breadcrumb-list-item'><button type='button' onClick={() => onDomesticHomeClick(dispatch)} >All Domestic Dioceses</button></li>
			<li className='clergycomp-infographic-breadcrumb-list-item'><button type='button' >{provMap?.filter(a => a.val === currentRegion)[0]?.text}</button></li>
		</ul>
	);

}

export function DioBackButtons() {
	const dispatch = useDispatch();
	const currentRegion = useSelector<TcsmStates, string>(state => state?.clergyCompReportState?.selectedRegion);
	const currentDio = useSelector<TcsmStates, string>(state => state?.clergyCompReportState?.selectedDio);

	return (
		<ul className='clergycomp-infographic-breadcrumb-list'>
			<li className='clergycomp-infographic-breadcrumb-list-item'><button type='button' onClick={() => onHomeClick(dispatch)}>Home</button></li>
			<li className='clergycomp-infographic-breadcrumb-list-item'><button type='button' onClick={() => onDomesticHomeClick(dispatch)} >All Domestic Dioceses</button></li>
			<li className='clergycomp-infographic-breadcrumb-list-item'><button type='button' onClick={() => provinceBackClick(dispatch, currentRegion)} >{provMap?.filter(a => a.val === currentRegion)[0]?.text}</button></li>
			<li className='clergycomp-infographic-breadcrumb-list-item'><button type='button' >{replaceAll(currentDio?.replace('Dio_', ''), '_', ' ')}</button></li>

		</ul>
	);

}


export function NonDomesticDioBackButtons() {
	const dispatch = useDispatch();
	const currentDio = useSelector<TcsmStates, string>(state => state?.clergyCompReportState?.selectedDio);

	return (
		<ul className='clergycomp-infographic-breadcrumb-list'>
			<li className='clergycomp-infographic-breadcrumb-list-item'><button type='button' onClick={() => onHomeClick(dispatch)}>Home</button></li>
			<li className='clergycomp-infographic-breadcrumb-list-item'><button type='button' onClick={() => internationalDioBackClick(dispatch)}>All Non-Domestic Dioceses</button></li>
			<li className='clergycomp-infographic-breadcrumb-list-item'><button type='button' >{replaceAll(currentDio?.replace('Dio_', ''), '_', ' ')}</button></li>
		</ul>
	);

}